import axios from 'axios';

// Force the API host to https so CORS preflight requests are not redirected
// (http://  or protocol-relative //  -> https://). A redirect on a preflight
// request is rejected by the browser.
function toHttps(host) {
  if (!host) return host;
  return host
    .trim()
    .replace(/^http:\/\//i, 'https://')
    .replace(/^\/\//, 'https://');
}

export function HTTP(token) {
  return axios.create({
    baseURL: toHttps(window.process && window.process.env && window.process.env.API_HOST_GLOBAL),
    headers: {
      Authorization: token
    }
  });
}



// WEBPACK FOOTER //
// ./src/core/http/http-token.js